import React from 'react';
import './AppTasks.css'

const AppTasks = () => {
    const taskData = [
        {
            title: 'Create an event',
            description: ['Create any type of event or party anywhere within Australia. The Elite Partyz App is perfect for kids birthdays, family functions,  weddings and business events, to name a few.'],
            displayImgPath: '/img/event.webp'
        },
        {
            title: 'Create your task list',
            description: ['With the Elite Partyz App you can create a custom To Do task list, making it impossible to forget everything you require for your event or party.', 'Simply mark the tasks as complete as you book, purchase and organise each part of your event or party.'],
            displayImgPath: '/img/task-screen.webp'
        },
        {
            title: 'Find Businesses & Services',
            description: ['Elite Partyz makes party and event planning like take a walk in the park. Find the products and services to create the best experience and amaze your guests.', 'Businesses will display based on categories, keywords and your events location, saving you many hours trying to phone or run around trying to organise every piece of your event manually.'],
            displayImgPath: '/img/services.webp'
        },
        {
            title: "Guest List management and RSVP's",
            description: ['Add guests directly from your phones contact list or manually add guests who are not already in your contacts.', 'With our invite all option, your guests will receive a SMS message to open and can see your party or event details, time and location. Your guests will be able to RSVP instantly.', 'You are able to monitor who is attending and who is unable to attend all within the Elite Partyz App.'],
            displayImgPath: '/img/task-screen.webp'
        },
        
    ]
    return (
        <div className="app-tasks-section">
            <section className="app-tasks-heading">
                <div className="container app-heading-content">
                    <h2 className="app-task-head">Eliminate hours of painstaking tasks when you can simply manage events all within Elite Partyz App</h2>
                </div>
            </section>
            <section className="all-tasks">
                <div className="container task-list">
                    {
                    /* === App task loop === */
                        taskData.map((task, index) => {
                            
                            return(
                                <div className="task-contents" key={`Task${index}`}>
                                    <div className="task-content-data">
                                        <h4 className="title">{task.title}</h4>
                                        {
                                            // === Multiple Description Loop ===
                                                task.description.map((text, i) => {
                                                    return(
                                                        <p className="description" key={`Description${i}`}>
                                                        {text}
                                                        </p>
                                                    )
                                                })
                                        }
                                    </div>
                                    <div className="task-img-data">
                                        <img src={task.displayImgPath} alt={task.title} className="task-img" />
                                    </div>
                                </div>
                            )
                        })
                    }
                    

                </div>
            </section>
        </div>
    )
}

export default AppTasks
